<template>
  <span class="match-alert-beacon"
        v-b-tooltip.hover.top="tooltip"
        :style="{ backgroundColor: color }"/>
</template>

<script>
// Маячок активного алерта на карточке матча в сетке.
// Позиционируется абсолютно, поэтому родительская карточка должна быть position: relative.
export default {
  name: 'MatchAlertBeacon',
  props: {
    color: {
      type: String,
      default: '#dc3545'
    },
    tooltip: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.match-alert-beacon {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.35);
  z-index: 20;
  animation: match-alert-beacon-blink 1s ease-in-out infinite;
}

@keyframes match-alert-beacon-blink {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.25;
    transform: scale(0.8);
  }
}
</style>
